
export default function BybitChangeKeysPermissions(): JSX.Element {
  return (
    <span className="message__note message__note--error">
      Keys are in "Read-Only" mode. Please change to "Read-Write"
    </span>
  );
}
